<div class="lg:flex lg:gap-4 bg-bleuCaliceo-300 px-10 pt-4">
  <div appAutoClose="always" class="relative mt-2 basis-1/2">
    <button aria-labelledby="centerChoice"
            class="bg-gray-100 py-5 px-4 pr-10 md:px-7 disabled:bg-gray-200 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
            type="button">
            <span class="flex items-center">
              <div class="w-12">
              <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60"
                   ngSrc="assets/icons/gray/location.svg"
                   width="60">
              </div>
                <span
                  class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                  <p class="font-semibold truncate text-xs"
                     id="centerChoice">{{ 'caliceoCenterChoice' | translate }}</p>
                  {{ selectionService.center()?.name }}
                </span>
            </span>
      <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                     <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
            </span>
    </button>
    <ul
      class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      role="listbox" tabindex="-1">

      @for (center of centerService.centers(); track center.id) {
        <li (click)="selectionService.center.set(center);"
            (keyup.enter)="emulateClick($event)"
            [attr.aria-selected]="selectionService.center()?.id === center.id"
            class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
            role="option"
            tabindex="0">
          <div class="flex items-center">
                <span [ngClass]="selectionService.center()?.id === center.id ? 'font-semibold' : 'font-normal'"
                      class="text-lg text-gray-500 ml-3 block truncate">
                  {{ center.name }} @if (center.city; as city) {
                  - {{ city }}
                }
                </span>
          </div>
        </li>
      }
    </ul>
  </div>
</div>

<app-products [content]="products()" [redirectUrl]="selectionService.center()?.url ?? ''"/>
